// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N50RENnP4KI1v3R9GFIz{align-items:center;color:var(--theme-link-color, #1f960b);display:flex;flex-direction:row;font-family:rubik,helvetica,arial,sans-serif;font-size:10px;font-weight:700}.X0X7JzUoNDPZoBiOHmqN{margin-right:3px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `N50RENnP4KI1v3R9GFIz`,
	"logoSvg": `X0X7JzUoNDPZoBiOHmqN`
};
export default ___CSS_LOADER_EXPORT___;
